import type { SectionStatus } from '../../types/canvas';

interface ActionBarProps {
  status: SectionStatus;
  onApprove?: () => void;
  onRefine?: () => void;
  onAnother?: () => void;
  onDefine?: () => void;
  refineDisabled?: boolean;
}

export function ActionBar({ status, onApprove, onRefine, onAnother, onDefine, refineDisabled }: ActionBarProps) {
  if (status === 'generating') return null;

  if (status === 'failed') {
    return (
      <div className="flex gap-2.5 mt-3 pt-2.5 border-t border-border items-center">
        {onDefine && (
          <button onClick={onDefine} className="text-xs font-semibold text-primary cursor-pointer border-none bg-transparent py-1">
            Define this
          </button>
        )}
        <button className="text-xs font-medium text-muted-foreground cursor-pointer border-none bg-transparent py-1">
          Let the press decide
        </button>
      </div>
    );
  }

  return (
    <div className="flex gap-2.5 mt-3 pt-2.5 border-t border-border items-center">
      {status !== 'approved' && onApprove && (
        <button onClick={onApprove} className="text-xs font-medium text-primary cursor-pointer border-none bg-transparent py-1">
          Approve
        </button>
      )}
      {onRefine && !refineDisabled && (
        <button onClick={onRefine} className="text-xs font-medium text-muted-foreground cursor-pointer border-none bg-transparent py-1 hover:text-foreground">
          Refine
        </button>
      )}
      {onAnother && (
        <button onClick={onAnother} className="text-xs font-medium text-muted-foreground cursor-pointer border-none bg-transparent py-1 hover:text-foreground">
          Another
        </button>
      )}
    </div>
  );
}
